// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  Container,
  Row,
  Input,
} from "reactstrap";

import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";

//data
import {
  TRANSACTION_API,
  TRANSACTION_TITLE_API,
} from "../../services/CONSTANTS";
import { getApiDataService } from "../../services/apiServices";
import styles from "./ImageUpload.module.css";
import { toast } from "react-toastify";
import UnitTransactionModal from "./unit-transaction-modal/UnitTransactionModa";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { DataTable, FilterBar, TablePagination } from "components/shared";

const TX_COLUMNS = [
  { key: "index", label: "#" },
  { key: "amount", label: "Amount" },
  { key: "spacer", label: "" },
  { key: "from", label: "From" },
  { key: "to", label: "To" },
  { key: "title", label: "Transaction Title" },
  { key: "created", label: "Created At" },
  { key: "actions", label: "" },
];

const UnitTransactionList = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [user_id, setUser_id] = useState("");
  const [userID, setUserID] = useState("");
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState({});
  const [status, setStatus] = useState("");
  const [status1, setStatus1] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [title, setTitle] = useState([]);
  const [searchId, setSearchId] = useState(null);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});

  let api = TRANSACTION_API + `?page=${page}&perPage=${perPage}`;
  api += searchId ? `&user_code=${searchId}` : "";
  api += status ? `&currency=${status}` : "";
  api += startDate ? `&start_date=${startDate}` : "";
  api += endDate ? `&end_date=${endDate}` : "";
  api += status1 ? `&transaction_title_id=${status1}` : "";
  var role = sessionStorage.getItem("user_role");

  useEffect(() => {
    getApiDataService(TRANSACTION_TITLE_API).then((res) => {
      setTitle(res.data);
    });
  }, []);
  useEffect(() => {
    fetchInitData();
  }, [api, status, endDate, status1]);

  const fetchInitData = () => {
    setIsLoading(true);
    getApiDataService(api)
      .then((res) => {
        console.log("res.data=", res.data);
        setUsers(res.data);
        setMeta(res.meta);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setUsers([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };
  const is_filtering = () => {
    let boo = false;
    let role = sessionStorage.getItem("user_role");
    if (
      role == "ADMIN" &&
      (status || searchId || endDate || startDate || status1)
    ) {
      boo = true;
    }
    if (
      role == "CS" &&
      (status || searchId || endDate || startDate || status1)
    ) {
      boo = true;
    }
    return boo;
  };

  const handleReset = () => {
    console.log("reset");
    setStatus(null);
    setUser_id(null);
    setStartDate(null);
    setStatus1("");
    setSearchId("");
    setEndDate(null);
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const handleStatus1 = (e) => {
    setStatus1(e.target.value);
  };

  const handleCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setStartDate(new Date(start).toLocaleDateString("fr-CA"));
    setEndDate(new Date(end).toLocaleDateString("fr-CA"));
  };

  const handleSearch = (e) => {
    setSearchId(e.target.value);
  };

  const searchFunction = (api) => {
    setTimeout(() => {
      // e.preventDefault();
      setUser_id(userID);
      console.log(user_id);
      setIsLoading(true);
      getApiDataService(api)
        .then((res) => {
          console.log("res.data=", res.data);
          setUsers(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("Error in useEffect!", err);
          setIsLoading(false);
          setUsers([]);
        });
      return () => {
        console.log("axios cleanup.");
      };
    }, 2000);
  };

  useEffect(() => {
    searchFunction(api);
  }, [searchId]);

  const closeModal = () => {
    setModal(false);
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7 akh-page-content" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar
                  title="Transaction Record"
                  onClear={handleReset}
                  isFiltering={is_filtering()}
                >
                  <DateRangePicker onCallback={handleCallback}>
                    <input
                      className="form-control akh-filter-width"
                      placeholder="Select date range"
                      aria-label="Date range"
                    />
                  </DateRangePicker>

                  <Input
                    className="akh-filter-select"
                    type="select"
                    value={status1}
                    onChange={handleStatus1}
                    aria-label="Filter by transaction type"
                  >
                    <option value="">All Transaction Type</option>
                    {title?.length !== 0
                      ? title?.map((item, index) =>
                          role == "RESELLER" ? (
                            (item?.name == "deposit" ||
                              item?.name == "withdraw") && (
                              <option key={item?.id || index} value={item?.id}>
                                {item?.name}
                              </option>
                            )
                          ) : (
                            <option key={item?.id || index} value={item?.id}>
                              {item?.name}
                            </option>
                          )
                        )
                      : null}
                  </Input>

                  {role != "RESELLER" && (
                    <>
                      <Input
                        className="akh-filter-select"
                        type="select"
                        value={status}
                        onChange={handleStatus}
                        aria-label="Filter by currency"
                      >
                        <option value="">All Currency</option>
                        <option value="MMK">MMK </option>
                        <option value="THB"> THB</option>
                      </Input>
                      <Input
                        className="akh-filter-width"
                        type="text"
                        placeholder="User Code "
                        aria-label="Search by user code"
                        value={searchId}
                        onChange={(e) => {
                          handleSearch(e);
                        }}
                      />
                    </>
                  )}
                </FilterBar>
              </CardHeader>
              <DataTable
                className="table-striped"
                columns={TX_COLUMNS}
                data={users}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(user, index) => (
                  <tr key={user?.id ?? index}>
                    <th>{index + 1}</th>
                    <td className="font-mono">
                      {user?.amount} {user?.currency}
                    </td>
                    <th scope="row"></th>
                    <td>
                      <span
                        className={styles.copyText}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            user?.to_user?.userCode
                          );
                          toast.success(
                            "User Id Copied" +
                              ` for ${user?.from_user?.name}`
                          );
                        }}
                      >
                        {user?.from_user?.name}
                        <Badge color="primary" pill className="font-mono">
                          {user?.from_user?.userCode}
                        </Badge>
                      </span>
                    </td>
                    <td>
                      <span
                        className={styles.copyText}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            user?.to_user?.userCode
                          );
                          toast.success(
                            "User Id Copied" + ` for ${user?.to_user?.name}`
                          );
                        }}
                      >
                        {user?.to_user?.name}
                        <Badge color="primary" pill className="font-mono">
                          {user?.to_user?.userCode}
                        </Badge>
                      </span>
                    </td>
                    <td>{user?.transaction_title?.name}</td>
                    <td>{new Date(user?.createdAt).toLocaleString()}</td>
                    <td className="text-right">
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => {
                          setUser_id(user?.to_user_id);
                          setItem(user);
                          setModal(true);
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                )}
              />
              <TablePagination meta={meta} page={page} setPage={setPage} />
            </Card>
          </div>
        </Row>
      </Container>
      <UnitTransactionModal
        modal={modal}
        setModal={setModal}
        item={item}
        onClose={closeModal}
        user_id={user_id}
      />
    </>
  );
};

export default UnitTransactionList;
